import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';

import {DictService} from '../../core/ecv-http-services/services/dict.service';
import {DialogService} from '../../dialog/dialog.service';
import {DictModel} from '../../dictionary/dict.model';
import {CustomValidators} from '../../core/validator/custom-validators';
import {ValidatorService} from '../../core/validator/validator.service';
import {BaseFillDataFormComponent} from '../../widgets/form-section/base-fill-data-form-component';
import {EcvLanguageService} from '../../core/ecv-language.service';
import {DictEnum} from '../../enums/dict.enum';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-certificate-item',
  templateUrl: './certificate-item.component.html'
})
export class CertificateItemComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  DictEnum = DictEnum;
  skillsDict: DictModel[] = [];
  certificateForm: FormGroup;
  dateForm: FormGroup;
  currentSkill: number;
  pendingDict: number[] = [];

  constructor(private dialogService: DialogService,
              private validatorService: ValidatorService,
              private langService: EcvLanguageService,
              private dictService: DictService) {
    super();
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.dateForm = new FormGroup({
      'certificateStartDate': new FormControl('', CustomValidators.validateDateFormats),
      'certificateEndDate': new FormControl('', CustomValidators.validateDateFormats)
    }, CustomValidators.validateDates('certificateStartDate', 'certificateEndDate'));
    this.certificateForm = new FormGroup({
      'certificateDictId': new FormControl('', CustomValidators.notEmpty),
      'certificateDictId-id': new FormControl('', CustomValidators.validateCorrectDict),
      'certificateSkill': new FormControl(''),
      'certificateSkill-id': new FormControl('', CustomValidators.validateCorrectDict),
      'certificateDate': this.dateForm
    });
    this.parentForm.addControl('certificateForm' + this.formIndex, this.certificateForm);
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('certificateForm' + this.formIndex);
  }

  addSkill() {
    if (!(this.data.skills.lastIndexOf(this.currentSkill) > -1) && !isNullOrUndefined(this.currentSkill)) {
      this.data.skills.unshift(this.currentSkill);
    }
    this.currentSkill = undefined;
  }

  removeSkill(index: number) {
    this.data.skills.splice(index, 1);
  }

  getSkillName(id: number): string {
    if (!id) {
      return '';
    }
    const foundSkill = this.skillsDict.find(x => x.id === id);
    if (!foundSkill) {
      if (this.pendingDict.find(x => x === id)) {
        return '';
      }
      this.pendingDict.push(id);
      this.dictService.getDictionary(id).subscribe(response => {
        if (!this.skillsDict.find(x => x.id === id)) {
          this.skillsDict.push(response);
        }
      });
      return '';
    }
    return this.langService.pickFromDictionary(foundSkill);
  }

  openModal(title: string, dictType: number, control: AbstractControl, maxLength: number, property: string) {
    this.dialogService.open(title, dictType, control, maxLength, this.data, property);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/certificate-item/certificate-item.component.ts